import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button, Card, Empty, Typography } from "antd";

const { Title, Text } = Typography

const ReportDetail = () => {
  const { id } = useParams();
  const [reportDetail, setReportDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const navigate = useNavigate()

  useEffect(() => {
    fetchReportDetail();
  }, [id]);

  const fetchReportDetail = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/TrainingProgressReport/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setReportDetail(response.data);
    } catch (error) {
      console.error("Error fetching report detail:", error);
      setReportDetail(null); // Error mein bhi null set karo
    }
    setLoading(false);
  };

  return (
     <Card
          loading={loading}
          className="card-professional"
          title="Report Detail"
          extra={<Button onClick={() => navigate(-1)}>Back</Button>}
        >
          {reportDetail ? (
            <div
              style={{
                maxHeight: '500px',
                overflowY: 'auto',
                paddingRight: '10px',
              }}
            >
              <Card
                style={{
                  marginBottom: 16,
                  borderRadius: 10,
                  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                  padding: 10,
                }}
              >
                <Title level={4} style={{ color: '#9A6B0E', marginBottom: 10 }}>
                  Learner : {reportDetail.learnerName}
                </Title>
    
                {/* Student Name & Group Name Inline */}
                <div style={{ display: 'flex', marginBottom: 10 }}>
                  <Text strong>Training Name: </Text>&nbsp;&nbsp;
                  <Text>{reportDetail.trainingTitle}</Text>
                </div>
                <div style={{ display: 'flex', marginBottom: 10 }}>
                  <Text strong>Group Name: </Text>&nbsp;&nbsp;
                  <Text>{reportDetail.groupName}</Text>
                </div>
    
                <Text strong>Description:</Text>
                <p style={{ marginBottom: 10 }}>{reportDetail.reportText}</p>
    
                <Text type="secondary">
                  Submitted on: {new Date(reportDetail.createdOn).toLocaleDateString()}
                </Text>
              </Card>
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '50px 0' }}>
              <Empty description="No report found" />
            </div>
          )}
        </Card>
  );
};

export default ReportDetail;
